import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import 'components/desktop/_general/SeasonalityBar/SeasonalityBar.scss';

interface IProps {
	seasonalityCode: number;
	currentMonthKey: number;
	className?: string;
	showIfSeasonalityCodeIsZero?: boolean;
}

const SeasonalityBarBig = (props: IProps) => {
	const { t } = useTranslation();

	if (props.seasonalityCode !== 0 || props.showIfSeasonalityCodeIsZero) {
		const monthsAvailabilities = [];
		const months = [
			t('months:JANUARY'),
			t('months:FEBRUARY'),
			t('months:MARCH'),
			t('months:APRIL'),
			t('months:MAY'),
			t('months:JUNE'),
			t('months:JULY'),
			t('months:AUGUST'),
			t('months:SEPTEMBER'),
			t('months:OCTOBER'),
			t('months:NOVEMBER'),
			t('months:DECEMBER'),
		];
		let binaryNumber: string = props.seasonalityCode.toString(2);
		binaryNumber = binaryNumber.split('').reverse().join('');

		for (let i = 0; i < 12; i++) {
			monthsAvailabilities.push(Boolean(binaryNumber[i] === '1'));
		}

		return (
			<>
				{monthsAvailabilities.map((monthAvailability, i) => (
					<td
						key={i} // Ensure each <td> has a unique key
						className={i === props.currentMonthKey - 1 ? 'table-active' : undefined}
						style={{
							textAlign: 'center',
							width: '5rem',
							color: monthAvailability ? '#88e1b9' : '#ffcaa7',
						}}
						title={months[i]}
					>
						<FontAwesomeIcon
							size="sm"
							icon={monthAvailability ? faCircleCheck : faCircleXmark}
						/>
					</td>
				))}
			</>
		);
	} else {
		return null; // or <React.Fragment></React.Fragment>
	}
};

export default SeasonalityBarBig;
